export default function FormSubmit({ onSubmit, children, className = "", ...formRest }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <form onSubmit={handleSubmit} className={className} {...formRest}>
      {children}
    </form>
  );
}
